import { render, staticRenderFns } from "./drawerDocumenti.vue?vue&type=template&id=6558e86b"
import script from "./drawerDocumenti.vue?vue&type=script&lang=js"
export * from "./drawerDocumenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports